import { call, put, takeLatest, select } from "redux-saga/effects";
import {
  getTransactionsSuccess,
  selectFilter,
} from "../slices/transactionState";
import { getTransaction } from "../../firebase-services/db-services";
function* async_getTransactionFetch() {
  const filter = yield select(selectFilter);

  const transaction = yield call(() => getTransaction(filter));
  const formattedTransaction = yield transaction.docs;
  console.log({ filter, transaction });
  const transactionData = formattedTransaction.map((doc) => {
    return { ...doc.data(), docid: doc.id };
  });
  console.log({ transactionData });
  yield put(getTransactionsSuccess(transactionData));
}
function* transactionSaga() {
  yield takeLatest(
    "transactions/getTransactionsFetch",
    async_getTransactionFetch
  );
}
export default transactionSaga;
